/** Плашка оценки исчезает сама, если пользователь её не трогал (IMPLEMENTATION.md §33). */
export const SUPPORT_FEEDBACK_TIMEOUT = 2 * 60 * 1000;
/** «Спасибо за оценку» держится столько и уходит. */
export const SUPPORT_FEEDBACK_THANKS_TIMEOUT = 5000;
export const SUPPORT_FEEDBACK_COMMENT_LIMIT = 500;
export const SUPPORT_FEEDBACK_ERROR_TEXT = 'Не удалось отправить оценку. Попробуйте ещё раз.';

/** Показ закончился при участии специалистов — пользователю предлагают его оценить. */
export interface ISupportFeedbackOffer {
    /** Сеанс поддержки — id показа */
    caseId: string;
    /** Специалисты, которые подключались к показу, в порядке подключения */
    names: readonly string[];
    /** Длительность показа, мин */
    minutes: number;
    /** Пользователь начал оценивать: плашка сама не исчезает */
    held?: boolean;
    /** Оценка принята: «Спасибо» и плашка уходит */
    sent?: boolean;
}

/** Сервер ещё закрывает показ (`Leave` в пути) — оценка уходит повторно через столько. */
export const SUPPORT_FEEDBACK_RETRY_DELAY = 1500;
export const SUPPORT_FEEDBACK_RETRIES = 2;
export const SUPPORT_FEEDBACK_EXPIRED_TEXT = 'Срок оценки истёк.';

/** Отказ оценки с понятной пользователю причиной. */
export class SupportFeedbackError extends Error {}

/**
 * Код отказа `POST supportSessions/feedback` (IMPLEMENTATION.md, «Отклонения этапа 5 потока S5»): 409
 * `already_rated` — оценка уже есть (из другой вкладки), для пользователя это успех; `not_ended` — сервер ещё не
 * закрыл показ; `expired` — прошло больше 24 ч.
 */
export function feedbackRejection(reason: unknown): 'already_rated' | 'not_ended' | 'expired' | null {
    const response = (reason as { response?: { status?: number; data?: { code?: unknown } } } | null)?.response;
    if (response?.status !== 409) return null;
    const code = response.data?.code;
    return code === 'not_ended' || code === 'expired' ? code : 'already_rated';
}
